import { useMemo } from 'react'
import { ChartOptions } from 'chart.js'
import styles from 'components/charts/Charts.module.scss'
import { Chart } from 'react-chartjs-2'
import { ConsumptionChartProps } from './types'
import { getConsumptionChartOptions } from './chartjs.config'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import classNames from 'classnames'

const ConsumptionChartDesktop = ({
  activeEnergyType,
  chartData,
  isFetchingVolumes,
  labels,
  minMaxData,
  granularity,
  setHoverDataPointIndex,
  compact
}: ConsumptionChartProps) => {
  const options = useMemo<ChartOptions<'bar'>>(
    () =>
      getConsumptionChartOptions({
        labels,
        handleHoverDataPoint: setHoverDataPointIndex,
        granularity,
        minMax: minMaxData,
        fuelType: activeEnergyType,
        isMobile: compact
      }),
    [labels, setHoverDataPointIndex, granularity, minMaxData, activeEnergyType, compact]
  )

  return !isFetchingVolumes ? (
    <div className={classNames(styles['chart-wrapper'], { [styles.compact]: !!compact })}>
      <Chart type="bar" options={options} data={chartData} className={styles.chart} />
    </div>
  ) : (
    <LoadingSkeleton>
      <LoadingSkeleton.Rectangle aspectRatio="3/1" />
    </LoadingSkeleton>
  )
}

export default ConsumptionChartDesktop
